import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import scaLogo from "../../../assets/Images/Logos/SCA.jpeg"

import "./CourseDetailsPageHeader.css";


const CourseDetailsPageHeader = (props) => {
  return (
    <Card id='detailLabel'>
      <CardHeader
        sx={{ height: "100px"}}
        avatar={
          <img src={scaLogo} alt='SCA LOGO' style={{marginLeft: "-15px", height: "120px"}} />
        }
        title={props.title}
      />
    </Card>
  );
}

export default CourseDetailsPageHeader;
